import React from "react";
import Footer from "../Footer";
import Content2026 from "../content2026";

function Productions2026() {
  return (
    <div className="page-wrapper">
      <Content2026 />
      <br></br>
      <Footer />
    </div>
  );
}

export default Productions2026;
